import styled from "styled-components";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
`;

export const ContainerWidth = styled.div`
  background-color: ${(props) => props?.backgroundColor ?? "inherit"};
  overflow: hidden;
  @media only screen and (min-width: 769px) {
    width: 1016px;
    z-index: 2;
  }
`;

export const JadwalKlasemenContainer = styled.div`
  max-height: 83px;
  min-height: 83px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  // background-color: #ffffff;
  padding-right: 16px;
  padding-left: 16px;
  gap: 4px 8px;
  margin-top: 11px;
  margin-bottom: 32px;
  cursor: pointer;

  @media only screen and (min-width: 769px) {
    max-height: 160px;
    min-height: 160px;
    gap: 8px 16px;
  }
`;

export const HighlightContainerOuter = styled.div`
  z-index: 2;
  padding: 24px 0px 24px 24px;
  overflow: auto;
  width: 100%;

  @media only screen and (min-width: 769px) {
    width: 1440px;
    padding: 72px 0px 45px 212px;
    margin-bottom: 48px;
  }
`;

export const HighlightContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  background-color: rgba(218, 247, 255, 0.3);
  ::-webkit-scrollbar {
    display: none;
  }
  z-index: 1;
  margin-top: -8px;

  @media only screen and (min-width: 769px) {
  }
`;

export const HighlightInnerContainer = styled.div`
  display: flex;
  overflow-y: hidden;
  height: 100%;
  max-width: 100%;
  gap: 24px;
  padding-right: 24px;
  z-index: 2;

  @media only screen and (min-width: 769px) {
    max-width: 1016px;
  }
`;

export const HighlightCard = styled.div`
  max-width: ${(props) =>
    props?.cardWidth ? `${props?.cardWidth}px` : "302px"};
  min-width: 302px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;

  @media only screen and (min-width: 769px) {
    max-width: ${(props) =>
      props?.cardWidth ? `${props?.cardWidth}px` : "323px"};
    min-width: ${(props) =>
      props?.cardWidth ? `${props?.cardWidth}px` : "323px"};
    text-wrap: balance;
  }
`;

export const SwooshSVG = styled.img`
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  z-index: 1 !important;

  @media only screen and (min-width: 769px) {
    top: -10rem !important;
  }
`;

export const FloatingIconWrapper = styled.div`
  @keyframes popout {
    from {
      transform: scale(0);
    }
    80% {
      transform: scale(1.2);
    }
    to {
      transform: scale(1);
    }
  }

  animation: popout 1s ease;
  position: fixed !important;
  top: 40vh !important;
  right: -15px;
  z-index: 3 !important;
  scale: 0.7;
  overflow-y: scroll;

  @media only screen and (min-width: 789px) {
    top: 80vh !important;
    right: 8vw;
    scale: 0.9;
  }

  // @media only screen and (min-width: 789px) and (max-width: 1030px) {
  //   top: 45vh !important;
  //   left: 25vw;
  //   scale: 0.9;
  // }

  // @media only screen and (min-width: 1031px) and (max-width: 1450px) {
  //   top: 45vh !important;
  //   left: 20vw;
  //   scale: 0.9;
  // }

  // @media only screen and (min-width: 1451px) {
  //   top: 45vh !important;
  //   left: 15vw;
  //   scale: 0.9;
  // }

  /* @media only screen and (min-width: 769px) and (max-width: 839px) {
    right: 18vw !important;
    scale: 0.55 !important;
    top: 50vw !important;
  }
  @media only screen and (min-width: 839px) and (max-width: 1080px) {
    right: 25vw !important;
    scale: 0.55 !important;
    top: 45vw !important;
  }
  @media only screen and (min-width: 1080px) {
    left: 25vw !important;
    right: -3vw !important;
    scale: 0.11 !important;
    top: 9vw !important;
  } */
`;

// export const LottieFloatingIcon = styled(Lottie)`
//   @keyframes popout {
//     from {
//       transform: scale(0);
//     }
//     80% {
//       transform: scale(1.2);
//     }
//     to {
//       transform: scale(1);
//     }
//   }

//   animation: popout 1s ease;
//   position: fixed !important;
//   top: 40% !important;
//   right: -30% !important;
//   z-index: 3 !important;
//   scale: 0.35;
//   overflow-y: scroll;

//   @media only screen and (min-width: 769px) and (max-width: 1079px) {
//     left: 49vw;
//   }
//   @media only screen and (min-width: 1080px) {
//     left: 49vw;
//   }
// `;

export const TextContainer = styled.div`
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.linenum || 2};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;

  @media only screen and (min-width: 769px) {
    -webkit-line-clamp: ${(props) => props.linenum || 3};
    -webkit-box-orient: vertical;
  }
`;

export const TypographyRegular = styled.p`
  margin: 0;
  color: ${(props) => props.color || ""};
  min-width: ${(props) => props.minwidth || "300px"};
  line-height: 13px;
  font-size: 11px;

  @media only screen and (min-width: 769px) {
    line-height: ${(props) => props.lineHeight || "24px"};
    font-size: ${(props) => props.fontSize || "18px"};
    min-width: ${(props) => props.minwidth || "323px"};
  }
`;

export const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${(props) => props.backgroundColor || "#fff"};
  margin-bottom: ${(props) => props.marginBottom || "32px"};
  padding-left: ${(props) => props.paddingLeft || "24px"};
  padding-right: ${(props) => props.paddingRight || "24px"};

  @media only screen and (min-width: 769px) {
    margin-bottom: 64px;
    padding-left: 0px;
    padding-right: ${(props) => props.paddingRight || "0px"};
  }
`;

export const ImageHighlight = styled.img`
  width: 300px;
  height: 160px;
  border-radius: 16px;
  margin-bottom: 13px;

  @media only screen and (min-width: 769px) {
    width: ${(props) => (props?.cardWidth ? `${props?.cardWidth}px` : "323px")};
    height: 175px;
    border-radius: 24px;
    margin-bottom: 24px;
  }
`;

export const ImageNews = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 16px;
`;

export const BigImageNews = styled.img`
  width: 598px;
  height: 393px;
  border-radius: 24px;
`;

export const NewsCard = styled.div`
  max-width: 316px;
  min-width: 316px;
  height: 100%;
  display: flex;
  gap: 20px;
  align-items: center;
  margin-top: 24px;
  cursor: pointer;

  @media only screen and (min-width: 769px) {
    max-width: 392px;
    min-width: 392px;
    border: 1px solid #f0f2f9;
    border-radius: 24px;
    padding: 16px;
  }
`;

export const BigNewsCard = styled.div`
  max-width: 598px;
  min-width: 598px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin-top: 24px;
  cursor: pointer;
`;

export const InnerNewsCard = styled.div`
  display: flex;
  flex-direction: Column;
  width: 100%;
  gap: 4px;
`;

export const BigInnerNewsCard = styled.div`
  display: flex;
  flex-direction: Column;
  width: 100%;
`;

export const NewsSectionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
  gap: 24px;

  @media only screen and (min-width: 769px) {
    display: flex;
    justify-content: start;
    flex-wrap: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
    width: 1016px;
  }
`;

export const OuterNewsContainer = styled.div`
  position: relative;
  @media only screen and (min-width: 769px) {
    &:after {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0;
      right: 0;
      bottom: 15px;
      pointer-events: none;
      background-image: linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        white 85%
      );
      width: 15%;
    }
  }
`;

export const GallerySectionContainer = styled.div`
  padding-top: 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
  overflow: hidden;

  @media only screen and (min-width: 769px) {
    gap: 24px;
    flex-wrap: nowrap;
  }
`;

export const GalleryCard = styled.div`
  background-image: ${(props) => `url('${props.img}')`};
  background-size: cover;
  background-repeat: no-repeat;
  width: 145px;
  height: 160px;
  display: flex;
  border-radius: 16px;
  align-items: end;
  cursor: pointer;

  @media only screen and (min-width: 769px) {
    width: 236px;
    height: 236px;
  }
`;

export const InnerGalleryCard = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  justify-content: end;
  padding: 16px;
  /* background-color: rgba(0, 0, 0, 0.4); */
`;

export const TypographyHeadline = styled.p`
  margin: 0px 0px 8px 0px;
  font-weight: bold;
  font-size: 13px;
  line-height: 20px;
  text-transform: uppercase;

  @media only screen and (min-width: 769px) {
    margin: 0;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const GalleryTitle = styled.p`
  margin: 0;
  color: #fff;
  line-height: 24px;
  font-weight: bold;
  font-size: 18px;
  margin-top: 8px;
  letter-spacing: 0.09px;
`;

export const HallOfFameTitle = styled.img`
  margin-bottom: 18px;
  margin-top: 32px;
`;
export const HallOfFameContainer = styled.div`
  background: ${(props) => props?.backgroundImage};
  background-repeat: no-repeat;
  background-position: left top, right bottom;
  width: 100vw;
  @media only screen and (min-width: 769px) {
  }
`;

export const CategoryTitle = styled.span`
  font-size: ${(props) => props?.fontSize ?? "18px"};
  color: white;
  font-family: "Gilroy";
  font-weight: ${(props) => props?.fontWeight ?? "bold"};
  white-space: pre;
`;

export const CategoryDetailBtn = styled.div`
  display: inline-flex;
  cursor: pointer;
  margin-left: auto;
  @media only screen and (min-width: 769px) {
    margin-left: 800px;
  }
`;

export const CategorySpacing = styled.div`
  display: flex;
  margin-right: 16px;
  @media only screen and (min-width: 769px) {
    margin-right: 32px;
  }
`;

export const PlayerContainer = styled.div`
  background-image: ${(props) => `url('${props?.backgroundImage}')`};
  background-position: center;
  border-radius: 16px;
  gap: 2px;
  width: 100%;
  max-width: 195px;
  min-height: 280px;
  padding: 16px 0px 0 0px;
  overflow: hidden;
  display: inline-block;
  margin-left: ${(props) => props?.marginLeft ?? 0};
  margin-right: ${(props) => props?.marginRight ?? 0};
  cursor: pointer;
  @media only screen and (min-width: 769px) {
    max-width: 236px;
    width: 100vw;
  }
  #player-label {
    align-items: center;
    display: flex;
  }
`;

export const TagPlayer = styled.div`
  border-radius: 4px;
  background: rgba(31, 45, 61, 0.7);
  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  width: fit-content;
`;

export const PlayerImg = styled.img`
  margin-left: auto;
  display: flex;
  width: 132px;
  height: ${(props) => props?.height ?? "167px"};
  object-fit: cover;
  transform: ${(props) => props?.transform ?? "rotate(0.0001deg)"};
  @media only screen and (min-width: 769px) {
    width: 162.04px;
    height: ${(props) => props?.height ?? "205.76px"};
    //height: 205.76px;
  }
`;

export const ContainerSchool = styled.div`
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  padding-left: 12px;
  padding-right: 12px;
  padding: 6px 12px;
  align-items: center;

  span {
    text-overflow: ellipsis;
    font-size: 13px;
    text-transform: uppercase;
    font-family: Gilroy;
    font-weight: bold;
    color: #1f2d3d;
    margin-left: 8px;
  }
`;

export const PlayerWrapper = styled.div`
  width: auto;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  @media only screen and (min-width: 769px) {
    overflow-x: hidden;
  }
`;

export const OnGoingTag = styled.div`
  background-color: #ff100d;
  border-radius: 24px;
  color: white;
  margin-left: 4px;
  margin-right: 12px;
  font-size: 10px;
  font-weight: bold;
  padding: 0px 4px;
`;

export const SliderContainer = styled.div`
  @media only screen and (min-width: 768px) {
    width: calc(100% + 96px);
  }
`;

export const InnerContainer = styled.div`
  position: relative;
  z-index: 1;

  @media only screen and (min-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1016px;
  }
`;

export const TimelineLabel = styled.h1`
  width: 100%;
  text-align: left;
  margin-top: 45px;
  margin-bottom: 20px;
`;
